
import * as busyCounter from '../../../shared/action-creators/busy-counter';
import {buildDealerRecommendationFilterPayload} from '../services/dealer-recommendation-helper';
import {getRecommendationBySearchType} from '../../shared/repositories/index';

export const updateRecommendationListFilterBy = (accounts, searchKey, searchType) =>
    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const dealerRecommendationPayload = buildDealerRecommendationFilterPayload(accounts, searchKey, searchType);
            const dealerRecommendations = await getRecommendationBySearchType(dealerRecommendationPayload);

            return dealerRecommendations;

        } catch (error) {

            throw error;

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/product/dealer-recommendations/action-creators/update-recommendation-list-filter-by.js